module.exports = __webpack_public_path__ + "img/xuesheng_renyuan.378607a8.png";